import React, { ReactNode } from 'react'
import { AuthProvider } from './AuthContext'
import { FavoritesProvider } from './FavoritesContext'

// Add more providers as needed

type Props = {
  children: ReactNode
}

export const Providers = ({ children }: Props) => {
  return (
    <AuthProvider>
      {/* Add more nested providers here */}
      <FavoritesProvider>{children}</FavoritesProvider>
    </AuthProvider>
  )
}
